<template>
  <div ref="hanatourHeader" class="hanatour-header"></div>
</template>

<script>
export default {
  props: {
    hanatourHost: String,
  },
  mounted() {
    const postscribe = require('postscribe')
    const hanatourHeaderEl = this.$refs.hanatourHeader
    const jsSrc = `<script src="${this.hanatourHost}/fx/lib/webtour_header.js"><\/script>`

    postscribe(hanatourHeaderEl, jsSrc, {
      autoFix: false,
      done: () => {
        wtjs.myinfo() // 하나투어 로그인 된 사용자 정보를 가져오기 위함
        $('.list_total_menu .ly_wrap a').click(function(e) {
          e.stopPropagation()
          location.href = e.target.innerHTML
        })
        const loginButton = document.querySelector('#gnb_wrap .global_menu_wrap .fr')

        if (loginButton) {
          loginButton.addEventListener('click', () => {
            history.replaceState({ loginFlag: true }, null, location.href)
          })
        }
        window.scrollTo(0,0)
      },
    })
  },
}
</script>

<style lang="scss" scoped>
.hanatour-header {
  height: 100%;
  box-sizing: border-box;
}
</style>
